import React from "react";
import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";
import { FormGroup, Label, Button, Col, Row, Card } from "reactstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { toast } from "react-toastify";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";

const CreateNewInfoPerson = (props) => {
  const intl = useIntl();
  const { values, errors, touched, isSubmitting } = props;

  return (
    <Card className="p-2">
      <Form>
        <Row>
          <Col lg={6}>
            <FormGroup>
              <Label>
                <FormattedMessage id="Name" />
              </Label>
              <Field
                className={`form-control ${
                  errors.personName && touched.personName && "is-invalid"
                }`}
                type="input"
                name="personName"
                placeholder={intl.formatMessage({ id: "Name" })}
                defaultValue={values.personName}
              />
              {errors.personName && touched.personName && (
                <div className="invalid-feedback">{errors.personName}</div>
              )}
            </FormGroup>
          </Col>
          <Col lg={6}>
            <FormGroup>
              <Label>
                <FormattedMessage id="Email" />
              </Label>
              <Field
                className={`form-control ${
                  errors.personEmail && touched.personEmail && "is-invalid"
                }`}
                type="input"
                name="personEmail"
                placeholder={intl.formatMessage({ id: "Email" })}
                defaultValue={values.personEmail}
              />
              {errors.personEmail && touched.personEmail && (
                <div className="invalid-feedback">{errors.personEmail}</div>
              )}
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={6}>
            <FormGroup>
              <Label>
                <FormattedMessage id="Phone" />{" "}
              </Label>
              <Field
                className={`form-control ${
                  errors.personPhone && touched.personPhone && "is-invalid"
                }`}
                type="input"
                name="personPhone"
                placeholder={intl.formatMessage({ id: "Phone" })}
                defaultValue={values.personPhone}
              />
              {errors.personPhone && touched.personPhone && (
                <div className="invalid-feedback">{errors.personPhone}</div>
              )}
            </FormGroup>
          </Col>
        </Row>

        <Button
          outline
          color="primary"
          type="submit"
          disabled={isSubmitting}
          className="m-2 float-end"
        >
          {isSubmitting ? (
            <FormattedMessage id="Wait" />
          ) : (
            <FormattedMessage id="AddPersons" />
          )}
        </Button>
      </Form>
    </Card>
  );
};

const FormikForm = withFormik({
  mapPropsToValues: (props) => ({
    personName: props.personName,
    personEmail: props.personEmail,
    personPhone: props.personPhone,
  }),
  validationSchema: Yup.object().shape({
    personName: Yup.string().required(<FormattedMessage id="Required" />),
    personEmail: Yup.string()
      .email(<FormattedMessage id="MustBeValidEmail" />)
      .max(255)
      .required(<FormattedMessage id="EmailRequired" />),
  }),

  handleSubmit(values, { props, resetForm, setSubmitting }) {
    let tempInformationPerson = {
      name: values.personName,
      mail: values.personEmail,
      phoneNumber: values.personPhone,
      forUsers: [],
      forUserIds: [],
    };

    if (props.periodId) {
      tempInformationPerson.aplPeriodId = props.periodId;
    }

    var tempInfoPersonList = [...props.informationPersons];
    tempInfoPersonList.push(tempInformationPerson);
    props.setInformationPersons(tempInfoPersonList);

    setSubmitting(false);
    resetForm({ values: { personName: "", personEmail: "", personPhone: "" } });

    toast.success(<FormattedMessage id="PersonAdded" />, TOAST_CONFIG);
  },
})(CreateNewInfoPerson);

export default FormikForm;
